(function(){
  var mm=window.matchMedia||function(){return{matches:false};};
  var reduce=mm('(prefers-reduced-motion: reduce)').matches;
  var fine=mm('(hover: hover) and (pointer: fine)').matches;

  // year
  document.querySelectorAll('[data-year]').forEach(function(el){el.textContent=new Date().getFullYear();});

  // mobile nav
  var burger=document.querySelector('.burger');
  if(burger){burger.addEventListener('click',function(){var m=document.querySelector('.menu');if(!m)return;m.style.display=(getComputedStyle(m).display==='none')?'flex':'none';});}

  // header condense on scroll
  var hdr=document.querySelector('header');
  function headerScroll(){if(hdr)hdr.classList.toggle('scrolled',window.scrollY>16);}

  // staggered scroll reveal
  document.querySelectorAll('.reveal').forEach(function(el){
    var p=el.parentElement;if(!p)return;
    var sibs=Array.prototype.filter.call(p.children,function(c){return c.classList&&c.classList.contains('reveal');});
    var i=sibs.indexOf(el);
    if(i>0)el.style.transitionDelay=Math.min(i*70,420)+'ms';
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  }else{document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});}

  // gallery thumbs with crossfade
  var gm=document.querySelector('#galleryMain');
  if(gm){gm.style.transition='opacity .35s ease';gm.addEventListener('load',function(){gm.style.opacity=1;});}
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click',function(){
      var img=t.querySelector('img');
      if(gm&&img){var src=img.getAttribute('data-full')||img.src;gm.style.opacity=0;setTimeout(function(){gm.src=src;},150);}
      document.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
    });
  });

  // pack tiers
  document.querySelectorAll('.tier').forEach(function(tr){tr.addEventListener('click',function(){document.querySelectorAll('.tier').forEach(function(x){x.classList.remove('active');});tr.classList.add('active');});});

  // inert forms
  document.querySelectorAll('form[data-thanks]').forEach(function(f){f.addEventListener('submit',function(ev){ev.preventDefault();var note=f.getAttribute('data-thanks')||'Thank you';var box=f.querySelector('input');if(box){box.value='';box.placeholder=note;box.blur();}var btn=f.querySelector('button');if(btn)btn.textContent='Done';});});

  // trust strip -> seamless infinite marquee with dot separators
  (function(){
    var strip=document.querySelector('.strip .strip-row');
    if(!strip||reduce)return;
    var labels=Array.prototype.map.call(strip.querySelectorAll('span'),function(s){return s.textContent.trim();}).filter(Boolean);
    if(!labels.length)return;
    function build(){
      strip.classList.add('is-marquee');strip.innerHTML='';
      var track=document.createElement('div');track.className='mq-track';strip.appendChild(track);
      var g=document.createElement('div');g.className='mq-group';track.appendChild(g);
      var need=strip.clientWidth+140,i=0,guard=0;
      while(g.scrollWidth<need&&guard<400){g.insertAdjacentHTML('beforeend','<span class="mq-item">'+labels[i%labels.length]+'</span>');i++;guard++;}
      track.appendChild(g.cloneNode(true));
      track.style.animationDuration=Math.max(18,g.scrollWidth/70)+'s';
    }
    build();
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(build,200);});
  })();

  headerScroll();
  window.addEventListener('scroll',headerScroll,{passive:true});
  if(reduce)return;

  // 3D pointer tilt
  function addTilt(el,max){
    var rx=0,ry=0,tz=0,raf=null,rect=null;
    function apply(){el.style.transform='perspective(950px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateZ('+tz+'px)';raf=null;}
    el.addEventListener('pointerenter',function(){rect=el.getBoundingClientRect();el.style.transition='transform .1s ease-out';});
    el.addEventListener('pointermove',function(e){if(!rect)rect=el.getBoundingClientRect();var dx=(e.clientX-rect.left)/rect.width-0.5,dy=(e.clientY-rect.top)/rect.height-0.5;ry=dx*max;rx=-dy*max;tz=10;if(!raf)raf=requestAnimationFrame(apply);});
    el.addEventListener('pointerleave',function(){el.style.transition='transform .6s cubic-bezier(.16,1,.3,1)';rx=ry=tz=0;apply();});
  }
  if(fine){
    document.querySelectorAll('.hero-frame').forEach(function(el){addTilt(el,8);});
    document.querySelectorAll('.pcard,.devcard,.gallery-main,.notify-art').forEach(function(el){addTilt(el,5);});
    // magnetic primary buttons
    document.querySelectorAll('.btn-gold').forEach(function(b){
      b.addEventListener('pointermove',function(e){var r=b.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-0.5,y=(e.clientY-r.top)/r.height-0.5;b.style.transform='translate('+(x*8)+'px,'+(y*6)+'px)';});
      b.addEventListener('pointerleave',function(){b.style.transform='';});
    });
    // hero glow follows pointer
    var heroArt=document.querySelector('.hero-art'),glow=document.querySelector('.hero-glow');
    if(heroArt&&glow){heroArt.addEventListener('pointermove',function(e){var r=heroArt.getBoundingClientRect();var x=(e.clientX-r.left)/r.width*100,y=(e.clientY-r.top)/r.height*100;glow.style.background='radial-gradient(circle at '+x+'% '+y+'%,rgba(200,162,76,.28),transparent 60%)';});}
  }

  // scroll parallax (opt-in via data-px)
  var px=[];
  document.querySelectorAll('[data-px]').forEach(function(el){px.push([el,parseFloat(el.getAttribute('data-px'))||0.05]);});
  var ticking=false;
  function onScroll(){if(ticking)return;ticking=true;requestAnimationFrame(function(){var vh=window.innerHeight;px.forEach(function(p){var r=p[0].getBoundingClientRect();var c=r.top+r.height/2-vh/2;p[0].style.transform='translateY('+(-c*p[1]).toFixed(1)+'px)';});ticking=false;});}
  if(px.length){window.addEventListener('scroll',onScroll,{passive:true});onScroll();}
})();
/* subscribe vs one-time toggle */
(function(){
  document.querySelectorAll('.subopt').forEach(function(o){
    o.addEventListener('click',function(){
      var grp=o.parentElement;
      grp.querySelectorAll('.subopt').forEach(function(x){x.classList.remove('active');});
      o.classList.add('active');
      var r=o.querySelector('input');if(r)r.checked=true;
    });
  });
})();
/* first-order popup */
(function(){
  var ov=document.getElementById('firstPop');
  if(!ov)return;
  var seen=false; try{seen=localStorage.getItem('preova_pop')==='1';}catch(e){}
  if(seen)return;
  var t=setTimeout(function(){ov.classList.add('show');},30000);
  function close(){ov.classList.remove('show');try{localStorage.setItem('preova_pop','1');}catch(e){}}
  ov.addEventListener('click',function(e){if(e.target===ov)close();});
  var x=ov.querySelector('.pop-x'); if(x)x.addEventListener('click',close);
  var f=ov.querySelector('form');
  if(f)f.addEventListener('submit',function(){try{localStorage.setItem('preova_pop','1');}catch(e){}});
})();
